/* DaLuca Stitching Color selected-state authority v1.3 */
(function(){
  'use strict';

  function items(){
    return Array.from(document.querySelectorAll('input[name="Stitching Color"]')).map(function(input){
      return input.closest('.gpo-swatches.image-swatches.gpo-ov-item');
    }).filter(Boolean);
  }

  function setImportant(el, prop, value){
    if(el) el.style.setProperty(prop, value, 'important');
  }

  function cleanItem(item){
    var input=item.querySelector('input[name="Stitching Color"]');
    var label=item.querySelector(':scope > label') || item.querySelector('label');
    var inner=item.querySelector('.gpo-swatch__inner');
    var img=inner && inner.querySelector('img.swatch-image');
    var selected=!!(input && input.checked);

    item.classList.toggle('daluca-stitch-color-selected', selected);

    [item,label,inner].forEach(function(el){
      if(!el) return;
      setImportant(el,'border','0');
      setImportant(el,'border-top','0');
      setImportant(el,'border-right','0');
      setImportant(el,'border-bottom','0');
      setImportant(el,'border-left','0');
      setImportant(el,'outline','0');
      setImportant(el,'box-shadow','none');
      setImportant(el,'text-decoration','none');
    });

    if(label){
      setImportant(label,'padding','0');
      setImportant(label,'margin','0');
      setImportant(label,'background','transparent');
    }
    if(inner){
      setImportant(inner,'padding','0');
      setImportant(inner,'background','transparent');
      setImportant(inner,'overflow','visible');
    }
    if(img){
      setImportant(img,'box-sizing','border-box');
      setImportant(img,'border', selected ? '2px solid #111111' : '1px solid #d6d9dc');
      setImportant(img,'outline','0');
      setImportant(img,'box-shadow','none');
      setImportant(img,'margin','0');
      setImportant(img,'padding','0');
    }
    item.querySelectorAll('.gpo-ov-extend').forEach(function(el){
      setImportant(el,'display','none');
      setImportant(el,'border','0');
      setImportant(el,'box-shadow','none');
    });
  }

  function sync(){ items().forEach(cleanItem); }
  function settle(){ sync(); setTimeout(sync,40); setTimeout(sync,140); }

  function start(){
    settle();
    [300,800,1600,3000].forEach(function(ms){setTimeout(sync,ms);});
    document.addEventListener('change',function(e){
      if(e.target && e.target.matches && e.target.matches('input[name="Stitching Color"]')) settle();
    },true);
    document.addEventListener('click',function(e){
      if(e.target && e.target.closest && e.target.closest('.gpo-swatches.image-swatches.gpo-ov-item') && e.target.closest('.gpo-swatches.image-swatches.gpo-ov-item').querySelector('input[name="Stitching Color"]')) settle();
    },true);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
